<template>
    <div class="contract-management">
        <!-- 헤더 -->
        <div class="content-header">
            <h3>
                <i class="fas fa-file-contract"></i>
                계약 관리
            </h3>
            <div class="header-content-group">
                <!-- 검색 바 -->
                <div class="search-bar-header">
                    <!-- <div class="form-field-inline">
                        <div class="search-input-group-header">
                            <i class="fas fa-search"></i>
                            <input
                                type="text"
                                v-model="searchKeyword"
                                placeholder="계약명/공급자명/요금표명 입력"
                                class="search-input-header"
                            />
                        </div>
                    </div> -->

                    <div class="form-field-inline">
                        <!-- <label>공급자</label> -->
                        <select v-model="filterSupplier" class="form-select-header">
                            <option value="">공급자 전체</option>
                            <option
                                v-for="supplier in uniqueSuppliers"
                                :key="supplier.supplierIdx"
                                :value="supplier.supplierIdx"
                            >
                                {{ supplier.supplierName }}
                            </option>
                        </select>
                    </div>

                    <!-- <div class="form-field-inline">
                        <button class="btn-search-header">
                            <i class="fas fa-search"></i>
                            검색
                        </button>
                    </div> -->
                </div>

                <div class="header-actions-group">
                    <!-- <button class="btn-action btn-excel" @click="exportToExcel">
                    <i class="fas fa-file-excel"></i>
                    Excel
                </button> -->
                    <button class="btn-action btn-primary" @click="openCreateForm">
                        <i class="fas fa-plus"></i>
                        신규 등록
                    </button>
                </div>
            </div>
        </div>

        <!-- 계약 목록 테이블 -->
        <div class="data-table-container">
            <table class="settings-data-table">
                <thead>
                    <tr>
                        <th>계약명</th>
                        <th>공급자</th>
                        <th>요금제</th>
                        <th>계약 기간</th>
                        <th>계약 용량</th>
                        <th>상태</th>
                        <th>작업</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="contract in filteredContracts"
                        :key="contract.contractIdx"
                        class="clickable-row"
                        @click="openViewForm(contract)"
                    >
                        <td>
                            <span class="contract-name">{{ contract.contractName || "-" }}</span>
                        </td>
                        <td>
                            <span class="supplier-text">{{ contract.supplier?.supplierName || "-" }}</span>
                        </td>
                        <td>
                            <span class="cost-text">{{ contract.cost?.costName || "-" }}</span>
                        </td>
                        <td>
                            <div class="period-info">
                                <span>{{ formatDate(contract.startDate) }}</span>
                                <span v-if="contract.endDate"> ~ {{ formatDate(contract.endDate) }}</span>
                                <span v-else class="ongoing-badge">진행중</span>
                            </div>
                        </td>
                        <td class="text-right">
                            <span class="capacity-text">{{ formatNumber(contract.contractCapacity) }}</span>
                        </td>
                        <td class="text-center">
                            <span :class="['status-badge', contract.enabled === 'Y' ? 'active' : 'inactive']">
                                {{ contract.enabled === "Y" ? "활성" : "비활성" }}
                            </span>
                        </td>
                        <td class="text-center" @click.stop>
                            <button class="btn-etc" @click="openContractDetailModal(contract)">
                                <i class="fas fa-cogs"></i>
                                기타요금 관리
                            </button>
                            <button class="btn-edit" @click="openRenewForm(contract)">
                                <i class="fas fa-sync-alt"></i>
                                계약 변경
                            </button>
                            <button class="btn-edit" @click="openEditForm(contract)">
                                <i class="fas fa-edit"></i>
                                정보 수정
                            </button>
                            <button class="btn-delete" @click="handleDelete(contract)">
                                <i class="fas fa-trash-alt"></i>
                                삭제
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <!-- 데이터 없음 -->
            <div v-if="filteredContracts.length === 0" class="no-data">
                <i class="fas fa-inbox"></i>
                <p>조회된 계약 정보가 없습니다.</p>
            </div>
        </div>

        <!-- 계약 등록/수정/상세 폼 (슬라이드 패널) -->
        <SettingsSidePanel :show="showForm" :title="formTitle" size="default" @close="closeForm">
            <div class="form-row">
                <!-- 계약명 -->
                <div class="form-group">
                    <label> 계약명 <span v-if="!isViewMode" class="required">*</span> </label>
                    <input type="text" v-model="form.contractName" class="form-input" :disabled="isViewMode" />
                </div>
                <!-- 관제점 선택 -->
                <div class="form-group">
                    <label> 관제점 <span v-if="!isViewMode" class="required">*</span> </label>
                    <div v-if="!isViewMode" class="custom-dropdown" :class="{ 'is-open': showPointDropdown }">
                        <div
                            class="custom-dropdown-trigger"
                            @click="togglePointDropdown"
                            :class="{ 'is-disabled': isViewMode }"
                        >
                            <span v-if="selectedPoint"> {{ selectedPoint.ptName }} ({{ selectedPoint.ptAddr }}) </span>
                            <span v-else class="placeholder">관제점 선택</span>
                            <i class="fas fa-chevron-down dropdown-icon"></i>
                        </div>
                        <div v-if="showPointDropdown" class="custom-dropdown-menu">
                            <div class="dropdown-search">
                                <input
                                    type="text"
                                    v-model="pointSearchKeyword"
                                    placeholder="관제점명 또는 주소로 검색..."
                                    class="dropdown-search-input"
                                    @click.stop
                                    @input="pointSearchKeyword = $event.target.value"
                                />
                                <i class="fas fa-search search-icon"></i>
                            </div>
                            <div class="dropdown-list">
                                <div v-if="filteredPoints.length === 0" class="dropdown-item no-results">
                                    검색 결과가 없습니다.
                                </div>
                                <div
                                    v-for="point in filteredPoints"
                                    :key="point.ptIdx"
                                    class="dropdown-item"
                                    :class="{ 'is-selected': form.ptIdx === point.ptIdx }"
                                    @click="selectPoint(point)"
                                >
                                    {{ point.ptName }} ({{ point.ptAddr }})
                                </div>
                            </div>
                        </div>
                    </div>
                    <select v-else v-model.number="form.ptIdx" class="form-select" :disabled="isViewMode">
                        <option :value="null">관제점 선택</option>
                        <option v-for="point in allPoints" :key="point.ptIdx" :value="point.ptIdx">
                            {{ point.ptName }} ({{ point.ptAddr }})
                        </option>
                    </select>
                    <small v-if="!isViewMode && selectedPointUnit" class="help-text">
                        계측단위: {{ selectedPointUnit }}
                    </small>
                </div>
            </div>
            <div class="form-row">
                <!-- 공급자 선택 -->
                <div class="form-group">
                    <label> 공급자 <span v-if="!isViewMode" class="required">*</span> </label>
                    <select
                        v-model.number="form.supplierIdx"
                        class="form-select"
                        :disabled="isViewMode"
                        @change="onSupplierChange"
                    >
                        <option :value="null">공급자 선택</option>
                        <option
                            v-for="supplier in allSuppliers"
                            :key="supplier.supplierIdx"
                            :value="supplier.supplierIdx"
                        >
                            {{ supplier.supplierName }}
                        </option>
                    </select>
                </div>
                <!-- 요금제 선택 -->
                <div class="form-group">
                    <label> 요금제 <span v-if="!isViewMode" class="required">*</span> </label>
                    <select
                        v-model.number="form.costIdx"
                        class="form-select"
                        :disabled="isViewMode || !form.supplierIdx"
                    >
                        <option :value="null">요금제 선택</option>
                        <option v-for="cost in filteredCosts" :key="cost.costIdx" :value="cost.costIdx">
                            {{ cost.costName }}
                        </option>
                    </select>
                    <small v-if="!isViewMode && !form.supplierIdx" class="help-text">공급자를 먼저 선택해주세요</small>
                    <small
                        v-if="!isViewMode && form.supplierIdx && selectedCost && selectedCost.billingUnit"
                        class="help-text"
                    >
                        과금단위: {{ selectedCost.billingUnit }}
                    </small>
                </div>
            </div>
            <!-- 계약 변경일 (계약 변경 모드일 때만 표시) -->
            <!-- <div v-if="isRenewMode" class="form-row">
                <div class="form-group" @click="toggleRenewDatePicker" style="cursor: pointer">
                    <label> 계약 변경일 <span class="required">*</span> </label>
                    <div class="date-picker-container" v-click-outside="closeRenewDatePicker">
                        <div class="date-display">
                            <span>{{ renewDateDisplay }}</span>
                            <i :class="['fas fa-chevron-down', { rotate: showRenewDatePicker }]"></i>
                        </div>
                        <div v-if="showRenewDatePicker" class="date-dropdown">
                            <div class="year-selector">
                                <button @click.stop="changeRenewYear(-1)">
                                    <i class="fas fa-chevron-left"></i>
                                </button>
                                <span>{{ renewDateYear }}</span>
                                <button @click.stop="changeRenewYear(1)">
                                    <i class="fas fa-chevron-right"></i>
                                </button>
                            </div>
                            <div class="month-grid">
                                <button
                                    v-for="month in 12"
                                    :key="month"
                                    :class="['month-btn', { active: month === renewDateMonth }]"
                                    @click.stop="selectRenewMonth(month)"
                                >
                                    {{ month }}월
                                </button>
                            </div>
                            <div v-if="renewDateMonth" class="day-grid">
                                <button
                                    v-for="day in renewDateDays"
                                    :key="day"
                                    :class="['day-btn', { active: day === renewDateDay }]"
                                    @click.stop="selectRenewDay(day)"
                                >
                                    {{ day }}일
                                </button>
                            </div>
                        </div>
                    </div>
                    <small class="help-text" style="display: block;">
                        기존 계약은 이 날짜 전날에 종료되고, 신규 계약은 이 날짜부터 시작됩니다.
                    </small>
                </div>
            </div> -->

            <div class="form-row">
                <div v-if="isRenewMode" class="form-group" @click="toggleRenewDatePicker" style="cursor: pointer">
                    <label> 계약 변경일 <span class="required">*</span> </label>
                    <div class="date-picker-container" v-click-outside="closeRenewDatePicker">
                        <div class="date-display">
                            <span>{{ renewDateDisplay }}</span>
                            <i :class="['fas fa-chevron-down', { rotate: showRenewDatePicker }]"></i>
                        </div>
                        <div v-if="showRenewDatePicker" class="date-dropdown">
                            <div class="year-selector">
                                <button @click.stop="changeRenewYear(-1)">
                                    <i class="fas fa-chevron-left"></i>
                                </button>
                                <span>{{ renewDateYear }}</span>
                                <button @click.stop="changeRenewYear(1)">
                                    <i class="fas fa-chevron-right"></i>
                                </button>
                            </div>
                            <div class="month-grid">
                                <button
                                    v-for="month in 12"
                                    :key="month"
                                    :class="['month-btn', { active: month === renewDateMonth }]"
                                    @click.stop="selectRenewMonth(month)"
                                >
                                    {{ month }}월
                                </button>
                            </div>
                            <div v-if="renewDateMonth" class="day-grid">
                                <button
                                    v-for="day in renewDateDays"
                                    :key="day"
                                    :class="['day-btn', { active: day === renewDateDay }]"
                                    @click.stop="selectRenewDay(day)"
                                >
                                    {{ day }}일
                                </button>
                            </div>
                        </div>
                    </div>
                    <small class="help-text" style="display: block">
                        기존 계약은 이 날짜 전날에 종료되고, 신규 계약은 이 날짜부터 시작됩니다.
                    </small>
                </div>
                <!-- 계약 기간 -->
                <div class="form-group" @click="toggleStartDatePicker" style="cursor: pointer">
                    <label> 계약 시작일 <span v-if="!isViewMode && !isRenewMode" class="required">*</span> </label>
                    <div class="date-picker-container" v-click-outside="closeStartDatePicker">
                        <div class="date-display" :class="{ disabled: isViewMode }">
                            <span>{{ startDateDisplay }}</span>
                            <i :class="['fas fa-chevron-down', { rotate: showStartDatePicker }]"></i>
                        </div>

                        <!-- 드롭다운 -->
                        <div v-if="showStartDatePicker" class="date-dropdown">
                            <div class="year-selector">
                                <button @click.stop="changeStartYear(-1)">
                                    <i class="fas fa-chevron-left"></i>
                                </button>
                                <span>{{ startDateYear }}</span>
                                <button @click.stop="changeStartYear(1)">
                                    <i class="fas fa-chevron-right"></i>
                                </button>
                            </div>
                            <div class="month-grid">
                                <button
                                    v-for="month in 12"
                                    :key="month"
                                    :class="['month-btn', { active: month === startDateMonth }]"
                                    @click.stop="selectStartMonth(month)"
                                >
                                    {{ month }}월
                                </button>
                            </div>
                            <div v-if="startDateMonth" class="day-grid">
                                <button
                                    v-for="day in startDateDays"
                                    :key="day"
                                    :class="['day-btn', { active: day === startDateDay }]"
                                    @click.stop="selectStartDay(day)"
                                >
                                    {{ day }}일
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group" @click="toggleEndDatePicker" style="cursor: pointer">
                    <label>계약 종료일</label>
                    <div class="date-picker-container" v-click-outside="closeEndDatePicker">
                        <div class="date-display" :class="{ disabled: isViewMode }">
                            <span>{{ endDateDisplay }}</span>
                            <i :class="['fas fa-chevron-down', { rotate: showEndDatePicker }]"></i>
                        </div>

                        <!-- 드롭다운 -->
                        <div v-if="showEndDatePicker" class="date-dropdown">
                            <div class="year-selector">
                                <button @click.stop="changeEndYear(-1)">
                                    <i class="fas fa-chevron-left"></i>
                                </button>
                                <span>{{ endDateYear }}</span>
                                <button @click.stop="changeEndYear(1)">
                                    <i class="fas fa-chevron-right"></i>
                                </button>
                            </div>
                            <div class="month-grid">
                                <button
                                    v-for="month in 12"
                                    :key="month"
                                    :class="['month-btn', { active: month === endDateMonth }]"
                                    @click.stop="selectEndMonth(month)"
                                >
                                    {{ month }}월
                                </button>
                            </div>
                            <div v-if="endDateMonth" class="day-grid">
                                <button
                                    v-for="day in endDateDays"
                                    :key="day"
                                    :class="['day-btn', { active: day === endDateDay }]"
                                    @click.stop="selectEndDay(day)"
                                >
                                    {{ day }}일
                                </button>
                            </div>
                            <!-- 미지정 버튼 -->
                            <div class="clear-date-section">
                                <button class="btn-clear-date" @click.stop="clearEndDate">
                                    <i class="fas fa-times-circle"></i>
                                    미지정
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Contract/Demand/PeakLinked일 때 계약 용량 표시 -->
            <div v-if="shouldShowContractCapacity()" class="form-row">
                <!-- 계약 용량 -->
                <div class="form-group">
                    <label>계약 용량 (kW) <span class="required">*</span></label>
                    <input
                        type="number"
                        v-model.number="form.contractCapacity"
                        placeholder="계약 용량 입력"
                        class="form-input"
                        step="0.01"
                        min="0"
                        :disabled="isViewMode"
                    />
                </div>
                <!-- Demand/PeakLinked일 때만 표시 (가스는 PeakLinked 제외) -->
                <div v-if="shouldShowDemandFields()" class="form-group">
                    <label>최대 수요 제한 (kW)</label>
                    <input
                        type="number"
                        v-model.number="form.maxDemandLimit"
                        placeholder="미설정"
                        class="form-input"
                        step="0.01"
                        :disabled="isViewMode"
                    />
                </div>
            </div>

            <div v-if="shouldShowDemandFields()" class="form-row">
                <!-- 한전 고객번호 -->
                <div class="form-group">
                    <label>한전 고객번호</label>
                    <select v-model="form.kepcoCustNo" class="form-select" :disabled="isViewMode">
                        <option :value="null">선택 안함</option>
                        <option v-for="customer in allKepcoCustomers" :key="customer.custNo" :value="customer.custNo">
                            {{ getCustomerDisplayName(customer) }}
                        </option>
                    </select>
                    <small v-if="!isViewMode" class="help-text">한전 청구 연동 사용 시 선택 가능</small>
                </div>
                <!-- 피크 최대수요전력 (PeakLinked이면서 가스가 아닐 때만) -->
                <div v-if="shouldShowPeakFields()" class="form-group">
                    <label>피크 최대수요전력 (kW)</label>
                    <input
                        type="number"
                        v-model.number="form.applyPeak"
                        placeholder="미입력"
                        class="form-input"
                        step="0.01"
                        min="0"
                        :disabled="isViewMode"
                    />
                    <small v-if="!isViewMode" class="help-text"
                        >피크연동형 요금제인 경우 고지서에 포함된 과금인정전력(kW) 값을 입력</small
                    >
                </div>
            </div>

            <!-- 검침일 -->
            <div class="form-row">
                <!-- 할인율 -->
                <div class="form-group">
                    <label>할인율 (%)</label>
                    <input
                        type="number"
                        v-model.number="form.discountRate"
                        placeholder="0.00"
                        class="form-input"
                        step="0.01"
                        min="0"
                        max="100"
                        :disabled="isViewMode"
                    />
                </div>
                <div class="form-group">
                    <label>검침일 (1~31)</label>
                    <input
                        type="number"
                        v-model.number="form.readingDay"
                        class="form-input"
                        step="1"
                        min="1"
                        max="31"
                        :disabled="isViewMode"
                    />
                </div>
            </div>

            <!-- GAS 에너지 유형일 때만 표시 -->
            <div v-if="isGasEnergyType()" class="form-row">
                <!-- 보정계수 -->
                <div v-if="shouldShowCorrectionFactor" class="form-group">
                    <label>보정계수</label>
                    <input
                        type="number"
                        v-model.number="form.correctionFactor"
                        placeholder="0"
                        class="form-input"
                        step="0.01"
                        :disabled="isViewMode"
                    />
                    <small v-if="!isViewMode" class="help-text"
                        >과금 사용량 환산에 적용되는 보정 계수 (기본값: 1.0)</small
                    >
                </div>
                <!-- 환산계수 -->
                <div v-if="shouldShowConversionFactor" class="form-group">
                    <label>환산계수</label>
                    <input
                        type="number"
                        v-model.number="form.conversionFactor"
                        placeholder="미입력 시 자동 계산"
                        class="form-input"
                        step="0.01"
                        :disabled="isViewMode"
                    />
                    <small v-if="!isViewMode" class="help-text" style="display: block">
                        공급사에서 제공하는 환산계수를 입력 ({{ selectedCost?.billingUnit }}/{{ selectedPointUnit }})
                    </small>
                    <small v-if="!isViewMode && defaultConversionFactor" class="help-text" style="display: block">
                        미입력 시 시스템 환산계수 ({{ defaultConversionFactor.toFixed(4) }}
                        {{ selectedCost?.billingUnit }}/{{ selectedPointUnit }}) 자동 적용.
                    </small>
                    <small
                        v-if="!isViewMode && !defaultConversionFactor && selectedPointUnit && selectedCost?.billingUnit"
                        class="help-text"
                        style="display: block"
                    >
                        미입력 시 환산되지 않으므로 반드시 환산계수를 확인하여 입력하세요.
                    </small>
                </div>
            </div>

            <div class="form-row">
                <!-- 최소 요금 -->
                <div class="form-group">
                    <label>최소 요금 (원)</label>
                    <input
                        type="number"
                        v-model.number="form.minFee"
                        placeholder="0"
                        class="form-input"
                        step="0.01"
                        :disabled="isViewMode"
                    />
                    <small v-if="!isViewMode" class="help-text" style="display: block">
                        총 요금이 최소 요금보다 적을 경우 최소 요금으로 계산.
                    </small>
                </div>
                <!-- 상태 -->
                <div class="form-group">
                    <label>상태</label>
                    <div class="radio-group">
                        <label class="radio-label">
                            <input type="radio" v-model="form.enabled" value="Y" :disabled="isViewMode" />
                            <span style="margin-left: 5px">활성</span>
                        </label>
                        <label class="radio-label">
                            <input type="radio" v-model="form.enabled" value="N" :disabled="isViewMode" />
                            <span style="margin-left: 5px">비활성</span>
                        </label>
                    </div>
                </div>
            </div>

            <!-- 계약 조건 -->
            <div class="form-group">
                <label>계약 조건</label>
                <textarea
                    v-model="form.contractConditions"
                    placeholder="계약 조건 입력"
                    rows="3"
                    class="form-textarea"
                    :disabled="isViewMode"
                ></textarea>
            </div>

            <!-- 상세 정보 (상세보기 모드일 때만 표시) -->
            <!-- <div v-if="isViewMode" class="detail-info">
                <div class="info-row">
                    <span class="info-label">등록일시:</span>
                    <span class="info-value">{{ form.regDate || "-" }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">등록자:</span>
                    <span class="info-value">{{ form.regWorker || "-" }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">수정일시:</span>
                    <span class="info-value">{{ form.modDate || "-" }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">수정자:</span>
                    <span class="info-value">{{ form.modWorker || "-" }}</span>
                </div>
            </div> -->
            <template #footer>
                <button class="btn-cancel" @click="closeForm">
                    <i class="fas fa-times"></i>
                    {{ isViewMode ? "닫기" : "취소" }}
                </button>
                <button v-if="!isViewMode" class="btn-save" @click="handleSave">
                    <i class="fas fa-save"></i>
                    저장
                </button>
            </template>
        </SettingsSidePanel>

        <!-- 기타요금 관리 모달 -->
        <ContractDetailModal ref="contractDetailModal" />
    </div>
</template>

<script>
import SettingsSidePanel from "../settings/SettingsSidePanel.vue";
import backEndApi from "@src/api/backEndApi.js";
import * as XLSX from "xlsx";
import ContractDetailModal from "../modals/ContractDetailModal.vue";
import { shouldShowField, isFieldRequired } from "@/utils/fieldDisplayHelper";

// Unit 클래스 import (xelib)
let Unit;
try {
    const xelib = require("xelib");
    Unit = xelib.PointBoxV2.Unit;
} catch (e) {
    // Fallback: Unit이 전역에 있을 수도 있음
    Unit = global.xe?.Unit || window.Unit;
}

export default {
    name: "ContractManagement",
    components: {
        SettingsSidePanel,
        ContractDetailModal,
    },
    directives: {
        clickOutside: {
            bind(el, binding) {
                el.clickOutsideEvent = function (event) {
                    if (!(el === event.target || el.contains(event.target))) {
                        binding.value(event);
                    }
                };
                document.body.addEventListener("click", el.clickOutsideEvent);
            },
            unbind(el) {
                document.body.removeEventListener("click", el.clickOutsideEvent);
            },
        },
    },
    data() {
        return {
            searchKeyword: "",
            filterSupplier: "",
            showForm: false,
            isViewMode: false,
            isEditMode: false,
            isRenewMode: false,
            editingContract: null,
            // 시작일 날짜 선택기
            showStartDatePicker: false,
            startDateYear: new Date().getFullYear(),
            startDateMonth: new Date().getMonth() + 1,
            startDateDay: new Date().getDate(),
            // 종료일 날짜 선택기
            showEndDatePicker: false,
            endDateYear: new Date().getFullYear(),
            endDateMonth: new Date().getMonth() + 1,
            endDateDay: new Date().getDate(),
            // 계약 변경일 날짜 선택기
            showRenewDatePicker: false,
            renewDateYear: new Date().getFullYear(),
            renewDateMonth: new Date().getMonth() + 1,
            renewDateDay: new Date().getDate(),
            form: {
                correctionFactor: 1,
                conversionFactor: null,
                contractName: null,
                ptIdx: null,
                supplierIdx: null,
                costIdx: null,
                startDate: null,
                endDate: null,
                contractCapacity: 0,
                discountRate: 0,
                minFee: 0,
                maxDemandLimit: null,
                contractConditions: null,
                enabled: "Y",
                readingDay: null,
                kepcoCustNo: null,
                applyPeak: null,
                regDate: null,
                regWorker: null,
                modDate: null,
                modWorker: null,
            },
            // API에서 로드된 데이터
            contracts: [],
            contractDetail: null,
            allPoints: [],
            pointSearchKeyword: "",
            showPointDropdown: false,
            allSuppliers: [],
            allCosts: [],
            allKepcoCustomers: [],
        };
    },
    computed: {
        startDateDisplay() {
            if (this.form.startDate) {
                const date = new Date(this.form.startDate);
                return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일`;
            }
            return `${this.startDateYear}년 ${this.startDateMonth}월 ${this.startDateDay}일`;
        },
        endDateDisplay() {
            if (this.form.endDate) {
                const date = new Date(this.form.endDate);
                return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일`;
            }
            return "제한없음";
        },
        startDateDays() {
            const daysInMonth = new Date(this.startDateYear, this.startDateMonth, 0).getDate();
            return Array.from({ length: daysInMonth }, (_, i) => i + 1);
        },
        endDateDays() {
            const daysInMonth = new Date(this.endDateYear, this.endDateMonth, 0).getDate();
            return Array.from({ length: daysInMonth }, (_, i) => i + 1);
        },
        renewDateDisplay() {
            if (this.renewDateYear && this.renewDateMonth && this.renewDateDay) {
                return `${this.renewDateYear}년 ${this.renewDateMonth}월 ${this.renewDateDay}일`;
            }
            return "날짜 선택";
        },
        renewDateDays() {
            if (!this.renewDateMonth) return [];
            const daysInMonth = new Date(this.renewDateYear, this.renewDateMonth, 0).getDate();
            return Array.from({ length: daysInMonth }, (_, i) => i + 1);
        },
        filteredContracts() {
            let filtered = [...this.contracts];

            // 공급자 필터링
            if (this.filterSupplier) {
                filtered = filtered.filter((c) => c.supplierIdx === parseInt(this.filterSupplier));
            }

            // 검색어 필터링 (계약명, 공급자명, 요금표명)
            if (this.searchKeyword.trim()) {
                const searchLower = this.searchKeyword.toLowerCase();
                filtered = filtered.filter(
                    (c) =>
                        c.contractName?.toLowerCase().includes(searchLower) ||
                        c.supplier?.supplierName?.toLowerCase().includes(searchLower) ||
                        c.cost?.costName?.toLowerCase().includes(searchLower),
                );
            }

            return filtered;
        },
        uniqueSuppliers() {
            const supplierMap = new Map();
            this.contracts.forEach((contract) => {
                if (contract.supplier) {
                    supplierMap.set(contract.supplier.supplierIdx, contract.supplier);
                }
            });
            return Array.from(supplierMap.values()).sort((a, b) => a.supplierName.localeCompare(b.supplierName));
        },
        filteredCosts() {
            if (!this.form.supplierIdx) return [];
            return this.allCosts.filter((c) => c.supplierIdx === this.form.supplierIdx);
        },
        selectedCost() {
            // 계약 상세보기 모드에서는 contractDetail의 cost 정보 사용
            if (this.isViewMode && this.contractDetail?.cost) {
                // allCosts에서 baseFeeCalcType 정보 가져오기
                const costFromList = this.allCosts.find((c) => c.costIdx === this.contractDetail.cost.costIdx);
                if (costFromList) {
                    return costFromList;
                }
            }
            // 일반 모드에서는 form의 costIdx 사용
            if (!this.form.costIdx) return null;
            return this.allCosts.find((c) => c.costIdx === this.form.costIdx);
        },
        selectedSupplier() {
            // 계약 상세보기 모드에서는 contractDetail의 supplier 정보 사용
            if (this.isViewMode && this.contractDetail?.supplier) {
                // allSuppliers에서 energySourceCode 정보 가져오기
                const supplierFromList = this.allSuppliers.find(
                    (s) => s.supplierIdx === this.contractDetail.supplier.supplierIdx,
                );
                if (supplierFromList) {
                    return supplierFromList;
                }
            }
            // 일반 모드에서는 form의 supplierIdx 사용
            if (!this.form.supplierIdx) return null;
            return this.allSuppliers.find((s) => s.supplierIdx === this.form.supplierIdx);
        },
        formTitle() {
            if (this.isViewMode) {
                return "계약 상세";
            } else if (this.isRenewMode) {
                return "계약 변경 (이력 관리)";
            } else if (this.isEditMode) {
                return "계약 정보 수정";
            } else {
                return "계약 등록";
            }
        },
        // 필터링된 관제점 목록
        filteredPoints() {
            if (!this.pointSearchKeyword || this.pointSearchKeyword.trim() === "") {
                return this.allPoints;
            }
            const keyword = this.pointSearchKeyword.toLowerCase().trim();
            return this.allPoints.filter((point) => {
                const ptName = (point.ptName || "").toLowerCase();
                const ptAddr = (point.ptAddr || "").toLowerCase();
                return ptName.includes(keyword) || ptAddr.includes(keyword);
            });
        },
        // 선택된 관제점
        selectedPoint() {
            if (!this.form.ptIdx) return null;
            return this.allPoints.find((p) => p.ptIdx === this.form.ptIdx);
        },
        // 선택된 관제점의 계측단위
        selectedPointUnit() {
            if (!this.selectedPoint) return null;
            // unitSmallCode 또는 rawUnit 필드 확인
            return this.selectedPoint.unitSmallCode || this.selectedPoint.rawUnit || null;
        },
        // 시스템 기본 환산계수 (Unit.convert 결과)
        defaultConversionFactor() {
            if (!this.selectedPointUnit || !this.selectedCost?.billingUnit) return null;

            // 같은 단위면 변환 불필요
            if (this.selectedPointUnit === this.selectedCost.billingUnit) return 1.0;

            try {
                if (!Unit || typeof Unit.convert !== "function") return null;
                // Unit.convert(1.0, rawUnit, billingUnit) 호출
                const result = Unit.convert(1.0, this.selectedPointUnit, this.selectedCost.billingUnit);
                // 변환 결과가 유효한 숫자인지 확인
                if (result != null && !isNaN(result) && isFinite(result) && result !== 1.0) {
                    return result;
                }
                return null;
            } catch (err) {
                console.warn("Unit conversion failed:", err);
                return null;
            }
        },
    },
    mounted() {
        this.loadData();
        this.loadPoints();
        this.loadSuppliers();
        this.loadCosts();
        this.loadKepcoCustomers();
        // 외부 클릭 시 드롭다운 닫기
        document.addEventListener("click", this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
    },
    methods: {
        /**
         * 필드 표시 규칙을 위한 컨텍스트 생성
         * @returns {object} 컨텍스트 객체
         */
        getContext() {
            return {
                baseFeeCalcType: this.selectedCost?.baseFeeCalcType,
                energySourceCode: this.selectedSupplier?.energySourceCode,
            };
        },
        async loadData() {
            try {
                const result = await backEndApi.energyBillCalc.getContractList();
                if (result.status === 200) {
                    this.contracts = result.data;
                } else {
                    this.$notify({
                        type: "warning",
                        title: "경고",
                        text: result.data.message,
                    });
                }
            } catch (error) {
                console.error("계약 목록 조회 실패:", error);
                this.$notify({
                    type: "error",
                    title: "오류",
                    text: "계약 목록을 불러오는데 실패했습니다.",
                });
            }
        },
        async loadDetailData(contractIdx) {
            try {
                const result = await backEndApi.energyBillCalc.getContract(contractIdx);
                if (result.status === 200) {
                    this.contractDetail = result.data;
                } else {
                    this.$notify({
                        type: "warning",
                        title: "경고",
                        text: result.data.message,
                    });
                }
            } catch (error) {
                console.error("계약 상세 조회 실패:", error);
                this.$notify({
                    type: "error",
                    title: "오류",
                    text: "계약 상세 조회에 실패했습니다.",
                });
            }
        },
        async loadPoints() {
            try {
                const result = await backEndApi.pointInfo.getPointList();
                if (result.status === 200) {
                    this.allPoints = result.data.filter((point) => point.energySplyTypeCode != null);
                }
            } catch (error) {
                console.error("관제점 목록 조회 실패:", error);
            }
        },
        togglePointDropdown() {
            if (this.isViewMode) return;
            this.showPointDropdown = !this.showPointDropdown;
            if (this.showPointDropdown) {
                // 드롭다운이 열릴 때 검색어 초기화
                this.$nextTick(() => {
                    const searchInput = this.$el.querySelector(".dropdown-search-input");
                    if (searchInput) {
                        searchInput.focus();
                    }
                });
            }
        },
        selectPoint(point) {
            this.form.ptIdx = point.ptIdx;
            this.showPointDropdown = false;
            this.pointSearchKeyword = "";
        },
        handleClickOutside(event) {
            const dropdown = this.$el?.querySelector(".custom-dropdown");
            if (dropdown && !dropdown.contains(event.target)) {
                this.showPointDropdown = false;
            }
        },
        async loadSuppliers() {
            try {
                const result = await backEndApi.energyBillCalc.getSupplierList({ energySourceCode: "", enabled: "" });
                if (result.status === 200) {
                    this.allSuppliers = result.data;
                }
            } catch (error) {
                console.error("공급자 목록 조회 실패:", error);
            }
        },
        async loadCosts() {
            try {
                const result = await backEndApi.energyBillCalc.getCostList({
                    supplierIdx: null,
                    costType: "",
                    enabled: "",
                });
                if (result.status === 200) {
                    this.allCosts = result.data;
                }
            } catch (error) {
                console.error("요금제 목록 조회 실패:", error);
            }
        },
        async loadKepcoCustomers() {
            try {
                const result = await backEndApi.kepco.getCustomerNumbers("active", 1, 100);
                if (result.status === 200 && result.data) {
                    // kepco-plugin API 응답 구조: { success: true, message: "...", data: { total, page, limit, totalPages, data: [...] } }
                    // axios 래핑 후: result.data = { success: true, message: "...", data: { ... } }
                    // 따라서 result.data.data = { total, page, limit, totalPages, data: [...] }
                    // 실제 배열은 result.data.data.data
                    if (
                        result.data.success &&
                        result.data.data &&
                        result.data.data.data &&
                        Array.isArray(result.data.data.data)
                    ) {
                        this.allKepcoCustomers = result.data.data.data;
                    } else {
                        console.warn("한전 고객번호 목록 데이터 구조가 예상과 다릅니다:", result.data);
                        // 빈 배열로 초기화 (데이터가 없는 경우)
                        this.allKepcoCustomers = [];
                    }
                } else {
                    console.warn("한전 고객번호 목록 API 응답이 200이 아닙니다:", result.status);
                    this.allKepcoCustomers = [];
                }
            } catch (error) {
                console.error("한전 고객번호 목록 조회 실패:", error);
                // kepco-plugin이 설치되지 않았거나 오류가 발생해도 계약 등록은 가능하도록 함
                this.allKepcoCustomers = [];
            }
        },
        onSupplierChange() {
            // 공급자 변경 시 요금제 초기화
            this.form.costIdx = null;
        },
        exportToExcel() {
            try {
                const excelData = this.filteredContracts.map((contract, index) => ({
                    순번: index + 1,
                    계약명: contract.contractName || "-",
                    관제점명: contract.point?.ptName || "-",
                    관제점주소: contract.point?.ptAddr || "-",
                    공급자: contract.supplier?.supplierName || "-",
                    요금제: contract.cost?.costName || "-",
                    시작일: contract.startDate || "-",
                    종료일: contract.endDate || "진행중",
                    계약용량: contract.contractCapacity || "0",
                    할인율: contract.discountRate || "0",
                    최소요금: contract.minFee || "0",
                    상태: contract.enabled === "Y" ? "활성" : "비활성",
                }));

                const worksheet = XLSX.utils.json_to_sheet(excelData);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "계약 목록");

                const columnWidths = [
                    { wch: 8 }, // 순번
                    { wch: 20 }, // 계약명
                    { wch: 20 }, // 관제점명
                    { wch: 20 }, // 관제점주소
                    { wch: 15 }, // 공급자
                    { wch: 20 }, // 요금제
                    { wch: 12 }, // 시작일
                    { wch: 12 }, // 종료일
                    { wch: 12 }, // 계약용량
                    { wch: 10 }, // 할인율
                    { wch: 12 }, // 최소요금
                    { wch: 8 }, // 상태
                ];
                worksheet["!cols"] = columnWidths;

                const today = new Date();
                const dateStr = today.toISOString().split("T")[0].replace(/-/g, "");
                const fileName = `계약목록_${dateStr}.xlsx`;

                XLSX.writeFile(workbook, fileName);

                this.$notify({
                    type: "success",
                    title: "성공",
                    text: "엑셀 파일이 다운로드되었습니다.",
                });
            } catch (error) {
                console.error("엑셀 다운로드 실패:", error);
                this.$notify({
                    type: "error",
                    title: "오류",
                    text: "엑셀 파일 다운로드에 실패했습니다.",
                });
            }
        },
        async openCreateForm() {
            this.isViewMode = false;
            this.isEditMode = false;
            this.editingContract = null;

            // 관제점 목록 다시 로드 (최신 데이터 보장)
            await this.loadPoints();
            this.resetForm();
            this.showForm = true;
        },
        async openViewForm(contract) {
            this.isViewMode = true;
            this.isEditMode = false;
            this.editingContract = contract;

            // 관제점 목록 다시 로드 (최신 데이터 보장)
            await this.loadPoints();
            await this.loadDetailData(contract.contractIdx);

            if (this.contractDetail) {
                this.form = {
                    correctionFactor: parseFloat(this.contractDetail.correctionFactor || 0),
                    conversionFactor:
                        this.contractDetail.conversionFactor !== null &&
                        this.contractDetail.conversionFactor !== undefined
                            ? parseFloat(this.contractDetail.conversionFactor)
                            : null,
                    contractName: this.contractDetail.contractName,
                    readingDay: this.contractDetail.readingDay,
                    ptIdx: this.contractDetail.ptIdx,
                    supplierIdx: this.contractDetail.supplierIdx,
                    costIdx: this.contractDetail.costIdx,
                    startDate: this.contractDetail.startDate,
                    endDate: this.contractDetail.endDate || null,
                    contractCapacity: parseFloat(this.contractDetail.contractCapacity || 0),
                    discountRate: parseFloat(this.contractDetail.discountRate || 0),
                    minFee: parseFloat(this.contractDetail.minFee || 0),
                    maxDemandLimit: this.contractDetail.maxDemandLimit
                        ? parseFloat(this.contractDetail.maxDemandLimit)
                        : null,
                    contractConditions: this.contractDetail.contractConditions || null,
                    enabled: this.contractDetail.enabled,
                    kepcoCustNo: this.contractDetail.kepcoCustNo || null,
                    applyPeak: this.contractDetail.applyPeak ? parseFloat(this.contractDetail.applyPeak) : null,
                    regDate: this.contractDetail.regDate || null,
                    regWorker: this.contractDetail.regWorker || null,
                    modDate: this.contractDetail.modDate || null,
                    modWorker: this.contractDetail.modWorker || null,
                };

                // 날짜 선택기 상태 설정
                if (this.form.startDate) {
                    const startDate = new Date(this.form.startDate);
                    this.startDateYear = startDate.getFullYear();
                    this.startDateMonth = startDate.getMonth() + 1;
                    this.startDateDay = startDate.getDate();
                }
                if (this.form.endDate) {
                    const endDate = new Date(this.form.endDate);
                    this.endDateYear = endDate.getFullYear();
                    this.endDateMonth = endDate.getMonth() + 1;
                    this.endDateDay = endDate.getDate();
                }
            }

            this.showForm = true;
        },
        async openEditForm(contract) {
            this.isViewMode = false;
            this.isEditMode = true;
            this.isRenewMode = false;
            this.editingContract = contract;

            // 관제점 목록 다시 로드 (최신 데이터 보장)
            await this.loadPoints();
            this.form = {
                correctionFactor: parseFloat(contract.correctionFactor || 0),
                conversionFactor:
                    contract.conversionFactor !== null && contract.conversionFactor !== undefined
                        ? parseFloat(contract.conversionFactor)
                        : null,
                contractName: contract.contractName,
                readingDay: contract.readingDay,
                ptIdx: contract.ptIdx,
                supplierIdx: contract.supplierIdx,
                costIdx: contract.costIdx,
                startDate: contract.startDate,
                endDate: contract.endDate || null,
                contractCapacity: parseFloat(contract.contractCapacity || 0),
                discountRate: parseFloat(contract.discountRate || 0),
                minFee: parseFloat(contract.minFee || 0),
                maxDemandLimit: contract.maxDemandLimit ? parseFloat(contract.maxDemandLimit) : null,
                contractConditions: contract.contractConditions || null,
                enabled: contract.enabled,
                kepcoCustNo: contract.kepcoCustNo || null,
                applyPeak: contract.applyPeak ? parseFloat(contract.applyPeak) : null,
            };

            // 날짜 선택기 상태 설정
            if (this.form.startDate) {
                const startDate = new Date(this.form.startDate);
                this.startDateYear = startDate.getFullYear();
                this.startDateMonth = startDate.getMonth() + 1;
                this.startDateDay = startDate.getDate();
            }
            if (this.form.endDate) {
                const endDate = new Date(this.form.endDate);
                this.endDateYear = endDate.getFullYear();
                this.endDateMonth = endDate.getMonth() + 1;
                this.endDateDay = endDate.getDate();
            }

            this.showForm = true;
        },
        async openRenewForm(contract) {
            this.isViewMode = false;
            this.isEditMode = false;
            this.isRenewMode = true;
            this.editingContract = contract;

            // 관제점 목록 다시 로드 (최신 데이터 보장)
            await this.loadPoints();
            this.form = {
                correctionFactor: parseFloat(contract.correctionFactor || 0),
                conversionFactor:
                    contract.conversionFactor !== null && contract.conversionFactor !== undefined
                        ? parseFloat(contract.conversionFactor)
                        : null,
                contractName: contract.contractName,
                readingDay: contract.readingDay,
                ptIdx: contract.ptIdx,
                supplierIdx: contract.supplierIdx,
                costIdx: contract.costIdx,
                startDate: contract.startDate,
                endDate: contract.endDate || null,
                contractCapacity: parseFloat(contract.contractCapacity || 0),
                discountRate: parseFloat(contract.discountRate || 0),
                minFee: parseFloat(contract.minFee || 0),
                maxDemandLimit: contract.maxDemandLimit ? parseFloat(contract.maxDemandLimit) : null,
                contractConditions: contract.contractConditions || null,
                enabled: contract.enabled,
                kepcoCustNo: contract.kepcoCustNo || null,
                applyPeak: contract.applyPeak ? parseFloat(contract.applyPeak) : null,
            };

            // 계약 변경일 초기화 (오늘 날짜로 설정)
            const today = new Date();
            this.renewDateYear = today.getFullYear();
            this.renewDateMonth = today.getMonth() + 1;
            this.renewDateDay = today.getDate();
            this.showRenewDatePicker = false;

            // 시작일 날짜 선택기 상태 설정 (계약 변경 모드에서는 선택 가능)
            if (this.form.startDate) {
                const startDate = new Date(this.form.startDate);
                this.startDateYear = startDate.getFullYear();
                this.startDateMonth = startDate.getMonth() + 1;
                this.startDateDay = startDate.getDate();
            } else {
                // 시작일이 없으면 오늘 날짜로 설정
                this.startDateYear = today.getFullYear();
                this.startDateMonth = today.getMonth() + 1;
                this.startDateDay = today.getDate();
            }
            if (this.form.endDate) {
                const endDate = new Date(this.form.endDate);
                this.endDateYear = endDate.getFullYear();
                this.endDateMonth = endDate.getMonth() + 1;
                this.endDateDay = endDate.getDate();
            }

            this.showForm = true;
        },
        closeForm() {
            this.showForm = false;
            this.isViewMode = false;
            this.isEditMode = false;
            this.isRenewMode = false;
            this.editingContract = null;
            this.contractDetail = null;
            this.resetForm();
        },
        resetForm() {
            this.pointSearchKeyword = "";
            this.showPointDropdown = false;
            this.form = {
                correctionFactor: 1,
                conversionFactor: null,
                ptIdx: null,
                supplierIdx: null,
                costIdx: null,
                contractName: null,
                startDate: null,
                endDate: null,
                contractCapacity: 0,
                discountRate: 0,
                minFee: 0,
                readingDay: 0,
                maxDemandLimit: null,
                contractConditions: null,
                enabled: "Y",
                kepcoCustNo: null,
                applyPeak: null,
            };
            // 날짜 선택기 초기화
            const today = new Date();
            this.startDateYear = today.getFullYear();
            this.startDateMonth = today.getMonth() + 1;
            this.startDateDay = today.getDate();
            this.endDateYear = today.getFullYear();
            this.endDateMonth = today.getMonth() + 1;
            this.endDateDay = today.getDate();
            this.showStartDatePicker = false;
            this.showEndDatePicker = false;
            // 계약 변경일 초기화 (기존 today 변수 재사용)
            this.renewDateYear = today.getFullYear();
            this.renewDateMonth = today.getMonth() + 1;
            this.renewDateDay = today.getDate();
            this.showRenewDatePicker = false;
        },
        // 시작일 날짜 선택기 메서드
        toggleStartDatePicker() {
            if (this.isViewMode) return;
            this.showStartDatePicker = !this.showStartDatePicker;
            if (this.showStartDatePicker && this.form.startDate) {
                const date = new Date(this.form.startDate);
                this.startDateYear = date.getFullYear();
                this.startDateMonth = date.getMonth() + 1;
                this.startDateDay = date.getDate();
            }
        },
        closeStartDatePicker() {
            this.showStartDatePicker = false;
        },
        changeStartYear(direction) {
            if (this.isViewMode) return;
            this.startDateYear += direction;
            // 년이 변경되면 일을 해당 월의 마지막 날로 조정 (윤년 고려)
            const daysInMonth = new Date(this.startDateYear, this.startDateMonth, 0).getDate();
            if (this.startDateDay > daysInMonth) {
                this.startDateDay = daysInMonth;
            }
            this.updateStartDate();
        },
        selectStartMonth(month) {
            if (this.isViewMode) return;
            this.startDateMonth = month;
            // 월이 변경되면 일을 해당 월의 마지막 날로 조정
            const daysInMonth = new Date(this.startDateYear, this.startDateMonth, 0).getDate();
            if (this.startDateDay > daysInMonth) {
                this.startDateDay = daysInMonth;
            }
            this.updateStartDate();
        },
        selectStartDay(day) {
            if (this.isViewMode) return;
            this.startDateDay = day;
            this.showStartDatePicker = false;
            this.updateStartDate();
        },
        toggleRenewDatePicker() {
            if (this.isViewMode) return;
            this.showRenewDatePicker = !this.showRenewDatePicker;
        },
        closeRenewDatePicker() {
            this.showRenewDatePicker = false;
        },
        changeRenewYear(direction) {
            if (this.isViewMode) return;
            this.renewDateYear += direction;
        },
        selectRenewMonth(month) {
            if (this.isViewMode) return;
            this.renewDateMonth = month;
            // 일이 선택되지 않았으면 1일로 설정
            if (!this.renewDateDay) {
                this.renewDateDay = 1;
            }
        },
        selectRenewDay(day) {
            if (this.isViewMode) return;
            this.renewDateDay = day;
            this.showRenewDatePicker = false;
        },
        subtractDays(dateStr, days) {
            const date = new Date(dateStr);
            date.setDate(date.getDate() - days);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        },
        updateStartDate() {
            const year = String(this.startDateYear);
            const month = String(this.startDateMonth).padStart(2, "0");
            const day = String(this.startDateDay).padStart(2, "0");
            this.form.startDate = `${year}-${month}-${day}`;
        },
        // 종료일 날짜 선택기 메서드
        toggleEndDatePicker() {
            if (this.isViewMode) return;
            this.showEndDatePicker = !this.showEndDatePicker;
            if (this.showEndDatePicker) {
                if (this.form.endDate) {
                    const date = new Date(this.form.endDate);
                    this.endDateYear = date.getFullYear();
                    this.endDateMonth = date.getMonth() + 1;
                    this.endDateDay = date.getDate();
                } else {
                    // 종료일이 null일 때는 기본값 설정 (선택 전까지는 null 유지)
                    const today = new Date();
                    this.endDateYear = today.getFullYear();
                    this.endDateMonth = today.getMonth() + 1;
                    this.endDateDay = today.getDate();
                }
            }
        },
        closeEndDatePicker() {
            this.showEndDatePicker = false;
        },
        changeEndYear(direction) {
            if (this.isViewMode) return;
            this.endDateYear += direction;
            // 년이 변경되면 일을 해당 월의 마지막 날로 조정 (윤년 고려)
            if (this.endDateMonth) {
                const daysInMonth = new Date(this.endDateYear, this.endDateMonth, 0).getDate();
                if (this.endDateDay && this.endDateDay > daysInMonth) {
                    this.endDateDay = daysInMonth;
                }
                this.updateEndDate();
            }
        },
        selectEndMonth(month) {
            if (this.isViewMode) return;
            this.endDateMonth = month;
            // 월이 변경되면 일을 해당 월의 마지막 날로 조정
            if (this.endDateDay) {
                const daysInMonth = new Date(this.endDateYear, this.endDateMonth, 0).getDate();
                if (this.endDateDay > daysInMonth) {
                    this.endDateDay = daysInMonth;
                }
            } else {
                // 일이 선택되지 않았으면 1일로 설정
                this.endDateDay = 1;
            }
            this.updateEndDate();
        },
        selectEndDay(day) {
            if (this.isViewMode) return;
            this.endDateDay = day;
            this.showEndDatePicker = false;
            this.updateEndDate();
        },
        updateEndDate() {
            // 월과 일이 모두 선택되었을 때만 날짜 설정
            if (this.endDateMonth && this.endDateDay) {
                const year = String(this.endDateYear);
                const month = String(this.endDateMonth).padStart(2, "0");
                const day = String(this.endDateDay).padStart(2, "0");
                this.form.endDate = `${year}-${month}-${day}`;
            } else {
                // 월이나 일이 선택되지 않았으면 null 유지
                this.form.endDate = null;
            }
        },
        clearEndDate() {
            if (this.isViewMode) return;
            // 종료일을 null로 초기화
            this.form.endDate = null;
            // 날짜 선택기 변수들도 초기화
            const today = new Date();
            this.endDateYear = today.getFullYear();
            this.endDateMonth = null;
            this.endDateDay = null;
            // 드롭다운 닫기
            this.showEndDatePicker = false;
        },
        async handleDelete(contract) {
            const confirm = await this.alertConfirmWarning(
                `'${contract.point?.ptName || ""}' 계약을 삭제하시겠습니까?`,
            );
            if (confirm.value) {
                try {
                    const result = await backEndApi.energyBillCalc.deleteContract(contract.contractIdx);
                    if (result.status === 200) {
                        await this.alertNoti("삭제되었습니다.");
                        this.closeForm();
                        this.loadData();
                    } else {
                        await this.alertWarning(result.data.message);
                    }
                } catch (error) {
                    console.error("계약 삭제 실패:", error);
                    await this.alertWarning("계약 삭제에 실패했습니다.");
                }
            }
        },
        async handleSave() {
            // 계약 변경 모드일 때 변경일 필수 검증
            if (this.isRenewMode) {
                if (!this.renewDateYear || !this.renewDateMonth || !this.renewDateDay) {
                    await this.alertWarning("계약 변경일을 선택해주세요.");
                    return;
                }
            }

            // 필수 입력 검증 (계약 변경 모드에서는 startDate가 필수가 아님)
            if (!this.form.ptIdx || !this.form.supplierIdx || !this.form.costIdx) {
                await this.alertWarning("필수 항목을 모두 입력해주세요.");
                return;
            }
            if (!this.isRenewMode && !this.form.startDate) {
                await this.alertWarning("계약 시작일을 입력해주세요.");
                return;
            }

            // baseFeeCalcType이 Contract/Demand/PeakLinked일 때 contractCapacity 필수 검증
            if (this.selectedCost) {
                const calcType = this.selectedCost.baseFeeCalcType;
                if (["Contract", "Demand", "PeakLinked"].includes(calcType)) {
                    if (!this.form.contractCapacity || this.form.contractCapacity <= 0) {
                        await this.alertWarning("계약 용량(contractCapacity)은 필수입니다.");
                        return;
                    }
                }
            }

            try {
                const payload = {
                    correctionFactor: this.form.correctionFactor || null,
                    // conversionFactor: 0이면 null로 변환 (서버에서도 처리하지만 프론트에서도 명시적으로 처리)
                    conversionFactor:
                        this.form.conversionFactor !== null &&
                        this.form.conversionFactor !== undefined &&
                        this.form.conversionFactor !== 0
                            ? this.form.conversionFactor
                            : null,
                    contractName: this.form.contractName,
                    ptIdx: this.form.ptIdx,
                    supplierIdx: this.form.supplierIdx,
                    costIdx: this.form.costIdx,
                    startDate: this.form.startDate,
                    endDate: this.form.endDate || null,
                    contractCapacity: this.form.contractCapacity || 0,
                    discountRate: this.form.discountRate || 0,
                    minFee: this.form.minFee || 0,
                    maxDemandLimit: this.form.maxDemandLimit || null,
                    contractConditions: this.form.contractConditions || null,
                    enabled: this.form.enabled,
                    readingDay: this.form.readingDay || 0,
                    kepcoCustNo: this.form.kepcoCustNo || null,
                    applyPeak: this.form.applyPeak ? parseFloat(this.form.applyPeak) : null,
                };

                let result;
                if (this.isRenewMode) {
                    // 계약 변경일 추가
                    const year = String(this.renewDateYear);
                    const month = String(this.renewDateMonth).padStart(2, "0");
                    const day = String(this.renewDateDay).padStart(2, "0");
                    payload.renewDate = `${year}-${month}-${day}`;
                    payload.contractIdx = this.editingContract.contractIdx;

                    const confirm = await this.alertConfirmWarning(
                        `기존 계약을 만료하고 새 계약을 생성하시겠습니까?\n` +
                            `기존 계약 종료일: ${this.subtractDays(payload.renewDate, 1)}\n` +
                            `신규 계약 시작일: ${payload.renewDate}`,
                    );
                    if (!confirm.value) return;
                    result = await backEndApi.energyBillCalc.renewContract(payload);
                } else if (this.isEditMode) {
                    const confirm = await this.alertConfirmWarning("계약 정보를 수정하시겠습니까?");
                    if (!confirm.value) return;
                    payload.contractIdx = this.editingContract.contractIdx;
                    result = await backEndApi.energyBillCalc.updateContract(payload);
                } else {
                    const confirm = await this.alertConfirmWarning("새로운 계약을 등록하시겠습니까?");
                    if (!confirm.value) return;
                    result = await backEndApi.energyBillCalc.insertContract(payload);
                }

                if (result.status === 200) {
                    await this.alertNoti(
                        this.isEditMode ? "계약 정보가 수정되었습니다." : "새로운 계약이 등록되었습니다.",
                    );
                    this.closeForm();
                    this.loadData();
                } else {
                    await this.alertWarning(result.data.message || "저장에 실패했습니다.");
                }
            } catch (error) {
                console.error("계약 저장 실패:", error);
                await this.alertWarning("계약 정보를 저장하는데 실패했습니다.");
            }
        },
        formatDate(dateStr) {
            if (!dateStr) return "-";
            return dateStr.substring(0, 10);
        },
        formatNumber(value) {
            return new Intl.NumberFormat("ko-KR").format(value || 0);
        },
        // 기타요금 관리 모달 열기
        openContractDetailModal(contract) {
            this.$refs.contractDetailModal.open(contract);
        },
        // 한전 고객번호 표시명 생성
        getCustomerDisplayName(customer) {
            if (!customer) return "";
            const name = customer.custNm || customer.displayName || customer.custNo || "";
            const custNo = customer.custNo || "";
            const ictg = customer.ictg || "";
            const ikw = customer.ikw || "";

            let displayText = name;
            if (custNo) {
                displayText += ` [${custNo}]`;
            }
            if (ictg) {
                displayText += ` - ${ictg}`;
            }
            if (ikw) {
                displayText += ` / ${ikw}kW`;
            }
            return displayText || custNo || "고객정보 없음";
        },
        // GAS 에너지 유형 여부 확인
        isGasEnergyType() {
            if (!this.selectedSupplier) return false;
            const energySourceCode = this.selectedSupplier.energySourceCode || "";
            return energySourceCode.toUpperCase() === "GAS";
        },
        // 계약 용량 필드 표시 여부 (유틸리티 함수 기반)
        shouldShowContractCapacity() {
            return shouldShowField("contractCapacity", this.getContext());
        },
        // Demand 필드 표시 여부 (유틸리티 함수 기반)
        shouldShowDemandFields() {
            return (
                shouldShowField("maxDemandLimit", this.getContext()) ||
                shouldShowField("kepcoCustNo", this.getContext())
            );
        },
        // Peak 필드 표시 여부 (유틸리티 함수 기반)
        shouldShowPeakFields() {
            return shouldShowField("applyPeak", this.getContext());
        },
        // 계약 용량 필수 여부
        isContractCapacityRequired() {
            return isFieldRequired("contractCapacity", this.getContext());
        },
        // 보정계수 표시 여부
        shouldShowCorrectionFactor() {
            return shouldShowField("correctionFactor", this.getContext());
        },
        // 환산계수 표시 여부
        shouldShowConversionFactor() {
            return shouldShowField("conversionFactor", this.getContext());
        },
    },
};
</script>

<style scoped>
.contract-management {
    height: 100%;
    display: flex;
    flex-direction: column;
}

/* 헤더 */
.content-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 1px solid var(--ebc-hairline);
}

.content-header h3 {
    font-size: 15px;
    font-weight: 700;
    color: var(--ebc-text);
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.content-header h3 i {
    color: var(--ebc-primary);
}

.header-content-group {
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1;
    justify-content: flex-end;
}

.header-actions-group {
    display: flex;
    gap: 8px;
    flex-shrink: 0;
}

.btn-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: var(--ebc-btn-h-md);
    padding: 0 14px;
    min-width: 64px;
    font-size: 12px;
    line-height: 1;
    white-space: nowrap;
    box-sizing: border-box;
    border: 1px solid var(--ebc-border);
    border-radius: var(--ebc-radius-xs);
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-action i {
    font-size: 12px;
}

.btn-excel {
    background: white;
    color: var(--ebc-positive);
    border-color: var(--ebc-positive);
}

.btn-excel:hover {
    background: var(--ebc-positive-tint);
}

.btn-primary {
    background: var(--ebc-primary);
    color: var(--ebc-surface);
    border: 1px solid var(--ebc-primary);
}

.btn-primary:hover {
    background: var(--ebc-primary-hover);
    border-color: var(--ebc-primary-hover);
    color: var(--ebc-surface);
}

/* 헤더 안의 검색 바 */
.search-bar-header {
    display: flex;
    align-items: center;
    gap: 12px;
}

.search-bar-header .form-field-inline {
    display: flex;
    align-items: center;
    gap: 8px;
}

.search-bar-header .form-field-inline label {
    font-size: 12px;
    font-weight: 600;
    color: var(--ebc-text);
    white-space: nowrap;
    margin: 0;
}

.search-input-group-header {
    position: relative;
    display: flex;
    align-items: center;
}

.search-input-group-header i {
    position: absolute;
    left: 10px;
    color: var(--ebc-text-muted);
    font-size: 12px;
    z-index: 1;
}

.search-input-header {
    padding: 6px 10px 6px 30px;
    border: 1px solid var(--ebc-hairline-strong);
    border-radius: var(--ebc-radius-sm);
    font-size: 12px;
    min-width: 200px;
    height: 32px;
    box-sizing: border-box;
}

.search-input-header:focus {
    outline: none;
    border-color: var(--ebc-primary);
    box-shadow: 0 0 0 2px var(--ebc-primary-tint);
}

.form-select-header {
    padding: 6px 10px;
    border: 1px solid var(--ebc-hairline-strong);
    border-radius: var(--ebc-radius-sm);
    font-size: 12px;
    transition: all 0.2s;
    min-width: 120px;
    height: 32px;
    background: var(--ebc-surface);
    cursor: pointer;
}

.form-select-header:focus {
    outline: none;
    border-color: var(--ebc-primary);
    box-shadow: 0 0 0 2px var(--ebc-primary-tint);
}

.btn-search-header {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: var(--ebc-btn-h-md);
    padding: 0 14px;
    min-width: 64px;
    font-size: 12px;
    line-height: 1;
    white-space: nowrap;
    box-sizing: border-box;
    border: none;
    border-radius: var(--ebc-radius-xs);
    background: var(--ebc-primary);
    color: white;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-search-header:hover {
    background: var(--ebc-primary-hover);
}

/* 데이터 테이블 */
.data-table-container {
    flex: 1;
    border: 1px solid var(--ebc-hairline);
    border-radius: var(--ebc-radius-md);
    overflow-y: auto;
    position: relative;
}

.settings-data-table {
    width: 100%;
    border-collapse: collapse;
}

.settings-data-table thead {
    background: var(--ebc-surface-sunken);
}

.settings-data-table th {
    padding: 12px 16px;
    text-align: left;
    font-size: 12px;
    font-weight: 700;
    color: var(--ebc-text-sub);
    border-bottom: 1px solid var(--ebc-hairline);
    position: sticky;
    top: 0;
    background: var(--ebc-surface-sunken);
    z-index: 10;
}

.settings-data-table tbody tr {
    border-bottom: 1px solid var(--ebc-track);
    transition: all 0.2s;
}

.settings-data-table tbody tr:hover {
    background: var(--ebc-surface-sunken);
}

.settings-data-table td {
    padding: 14px 16px;
    font-size: 13px;
    color: var(--ebc-text);
}

.point-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.contract-name {
    font-weight: 600;
    color: var(--ebc-text);
}

.supplier-text {
    font-weight: 500;
    color: var(--ebc-text);
}

.cost-text {
    font-weight: 500;
}

.period-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    font-size: 12px;
}

.ongoing-badge {
    display: inline-block;
    padding: 2px 8px;
    background: var(--ebc-positive-tint);
    color: var(--ebc-positive);
    border-radius: var(--ebc-radius-xs);
    font-size: 11px;
    font-weight: 600;
    margin-top: 2px;
}

.capacity-text {
    font-weight: 600;
    color: var(--ebc-text);
}

.status-badge {
    display: inline-block;
    padding: 4px 12px;
    border-radius: var(--ebc-radius-xs);
    font-size: 12px;
    font-weight: 600;
}

.status-badge.active {
    background: var(--ebc-positive-tint);
    color: var(--ebc-positive);
}

.status-badge.inactive {
    background: var(--ebc-danger-tint);
    color: var(--ebc-danger);
}

.btn-edit {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: var(--ebc-btn-h-sm);
    padding: 0 10px;
    min-width: 44px;
    font-size: 11px;
    line-height: 1;
    white-space: nowrap;
    box-sizing: border-box;
    background: white;
    border: 1px solid var(--ebc-border-strong);
    border-radius: var(--ebc-radius-xs);
    color: var(--ebc-text);
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    margin-right: 4px;
}

.btn-edit:hover {
    background: var(--ebc-track);
    border-color: var(--ebc-text-muted);
}

.btn-edit i {
    font-size: 11px;
}

.btn-delete {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: var(--ebc-btn-h-sm);
    padding: 0 10px;
    min-width: 44px;
    font-size: 11px;
    line-height: 1;
    white-space: nowrap;
    box-sizing: border-box;
    background: white;
    border: 1px solid var(--ebc-danger);
    border-radius: var(--ebc-radius-xs);
    color: var(--ebc-danger);
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-delete:hover {
    background: var(--ebc-danger-tint);
}

.btn-delete i {
    font-size: 11px;
}

.btn-etc {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: var(--ebc-btn-h-sm);
    padding: 0 10px;
    min-width: 44px;
    font-size: 11px;
    line-height: 1;
    white-space: nowrap;
    box-sizing: border-box;
    background: white;
    border: 1px solid var(--ebc-border-strong);
    border-radius: var(--ebc-radius-xs);
    color: var(--ebc-text);
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    margin-right: 4px;
}

.btn-etc:hover {
    background: var(--ebc-track);
    border-color: var(--ebc-text-muted);
}

.btn-etc i {
    font-size: 11px;
}

.clickable-row {
    cursor: pointer;
}

.clickable-row:hover {
    background: var(--ebc-surface-sunken) !important;
}

.text-center {
    text-align: center !important;
}

.text-right {
    text-align: right !important;
}

/* 데이터 없음 */
.no-data {
    text-align: center;
    padding: 60px 20px;
    color: var(--ebc-text-muted);
}

.no-data i {
    font-size: 28px;
    margin-bottom: 16px;
    opacity: 0.5;
}

.no-data p {
    margin: 0;
    font-size: 14px;
}

/* 테이블 푸터 */
.table-footer {
    margin-top: 12px;
    padding: 12px 16px;
    background: var(--ebc-surface-sunken);
    border-radius: var(--ebc-radius-sm);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.total-count {
    font-size: 13px;
    font-weight: 600;
    color: var(--ebc-text-sub);
}

/* 슬라이드 패널 (등록/수정 폼) */

.detail-info {
    margin-top: 24px;
    padding: 12px 16px;
    background: var(--ebc-surface-sunken);
    border-radius: var(--ebc-radius-sm);
    border: 1px solid var(--ebc-border);
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: center;
}

.info-row {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 0;
    border: none;
}

.info-row:last-child {
    border-bottom: none;
}

.info-label {
    font-size: 11px;
    font-weight: 700;
    color: var(--ebc-text-sub);
    white-space: nowrap;
}

.info-value {
    font-size: 12px;
    color: var(--ebc-text);
    font-weight: 500;
}

.form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 20px;
    margin-right: 0px !important;
    margin-left: 0px !important;
}

.form-group {
    margin-bottom: 0px !important;
}

.form-group label {
    display: block;
    margin-bottom: 6px;
    font-size: 13px;
    font-weight: 600;
    color: var(--ebc-text);
}

.required {
    color: var(--ebc-danger);
}

.form-input,
.form-select,
.form-textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid var(--ebc-hairline-strong);
    border-radius: var(--ebc-radius-sm);
    font-size: 13px;
    transition: all 0.2s;
}

.form-textarea {
    resize: none;
    overflow-y: auto;
}

.form-input:focus,
.form-select:focus,
.form-textarea:focus {
    outline: none;
    border-color: var(--ebc-primary);
    box-shadow: 0 0 0 3px var(--ebc-primary-tint);
}

.form-input:disabled,
.form-select:disabled,
.form-textarea:disabled {
    background: var(--ebc-track);
    color: var(--ebc-text-sub);
    cursor: not-allowed;
    border-color: var(--ebc-hairline-strong);
}

.help-text {
    display: block;
    margin-top: 4px;
    font-size: 11px;
    color: var(--ebc-text-muted);
}

.radio-group {
    display: flex;
    gap: 12px;
    padding: 8px 0;
}

.radio-label {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    padding: 6px 16px;
    border: 2px solid var(--ebc-hairline-strong);
    border-radius: var(--ebc-radius-sm);
    background: var(--ebc-surface);
    transition: all 0.3s ease;
}

.radio-label:hover:not(:has(input[type="radio"]:disabled)) {
    border-color: var(--ebc-primary);
    background: var(--ebc-warn-tint);
}

.radio-label input[type="radio"] {
    cursor: pointer;
    width: 18px;
    height: 18px;
    accent-color: var(--ebc-primary);
    margin: 0;
    vertical-align: middle;
}

.radio-label:has(input[type="radio"]:checked) {
    border-color: var(--ebc-primary);
    background: var(--ebc-primary-tint);
    color: var(--ebc-primary);
}

.radio-label:has(input[type="radio"][value="Y"]:checked) {
    border-color: var(--ebc-positive);
    background: var(--ebc-positive-tint);
    color: var(--ebc-positive);
}

.radio-label:has(input[type="radio"][value="Y"]:checked) input[type="radio"] {
    accent-color: var(--ebc-positive);
}

.radio-label:has(input[type="radio"][value="N"]:checked) {
    border-color: var(--ebc-danger);
    background: var(--ebc-danger-tint);
    color: var(--ebc-danger);
}

.radio-label:has(input[type="radio"][value="N"]:checked) input[type="radio"] {
    accent-color: var(--ebc-danger);
}

.radio-label:has(input[type="radio"]:disabled) {
    opacity: 0.6;
    cursor: not-allowed;
    background: var(--ebc-track);
}

.radio-label span {
    user-select: none;
}

.btn-cancel,
.btn-save {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: var(--ebc-btn-h-md);
    padding: 0 14px;
    min-width: 64px;
    font-size: 12px;
    line-height: 1;
    white-space: nowrap;
    box-sizing: border-box;
    border: 1px solid var(--ebc-border);
    border-radius: var(--ebc-radius-xs);
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-cancel {
    background: white;
    color: var(--ebc-text-sub);
}

.btn-cancel:hover {
    background: var(--ebc-track);
}

.btn-save {
    background: var(--ebc-primary);
    color: var(--ebc-surface);
    border: 1px solid var(--ebc-primary);
}

.btn-save:hover {
    background: var(--ebc-primary-hover);
    border-color: var(--ebc-primary-hover);
    color: var(--ebc-surface);
}

/* 날짜 선택기 스타일 (CostManagement와 동일) */
.date-picker-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--ebc-surface);
    border: 1px solid var(--ebc-hairline);
    border-radius: var(--ebc-radius-md);
    padding: 2px;
    z-index: 100;
}

.date-display {
    padding: 6px 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 120px;
    justify-content: center;
    border-radius: var(--ebc-radius-sm);
    transition: all 0.2s ease;
    color: var(--ebc-text);
    font-weight: 600;
    font-size: 13px;
}

.date-display:hover:not(.disabled) {
    background: var(--ebc-track);
}

.date-display.disabled {
    cursor: not-allowed;
    opacity: 0.6;
}

.date-display i {
    font-size: 10px;
    transition: transform 0.2s ease;
}

.date-display i.rotate {
    transform: rotate(180deg);
}

.date-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    background: white;
    border: 1px solid var(--ebc-border);
    border-radius: var(--ebc-radius-md);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    z-index: 101;
    margin-top: 6px;
    padding: 16px;
    min-width: 240px;
}

.year-selector {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid var(--ebc-border);
}

.year-selector button {
    background: var(--ebc-surface-sunken);
    border: 1px solid var(--ebc-border);
    padding: 4px 8px;
    cursor: pointer;
    color: var(--ebc-text-sub);
    border-radius: var(--ebc-radius-xs);
    transition: all 0.2s ease;
    font-weight: 600;
    font-size: 12px;
}

.year-selector button:focus {
    outline: none;
}

.year-selector button:hover {
    background: var(--ebc-primary);
    color: white;
    border-color: var(--ebc-primary);
}

.year-selector span {
    font-size: 14px;
    font-weight: 700;
    color: var(--ebc-text);
}

.month-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
}

.month-btn {
    background: var(--ebc-surface-sunken);
    border: 1px solid var(--ebc-border);
    padding: 8px 4px;
    cursor: pointer;
    border-radius: var(--ebc-radius-xs);
    font-size: 11px;
    font-weight: 600;
    color: var(--ebc-text-sub);
    transition: all 0.2s ease;
    text-align: center;
}

.month-btn:hover {
    background: var(--ebc-border);
    border-color: var(--ebc-border-strong);
    color: var(--ebc-text);
}

.month-btn.active {
    background: var(--ebc-primary);
    border-color: var(--ebc-primary);
    color: white;
    box-shadow: 0 1px 4px var(--ebc-primary-tint-strong);
}

.day-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 4px;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid var(--ebc-border);
}

.day-btn {
    background: var(--ebc-surface-sunken);
    border: 1px solid var(--ebc-border);
    padding: 6px 4px;
    cursor: pointer;
    border-radius: var(--ebc-radius-xs);
    font-size: 11px;
    font-weight: 600;
    color: var(--ebc-text-sub);
    transition: all 0.2s ease;
    text-align: center;
}

.day-btn:hover {
    background: var(--ebc-border);
    border-color: var(--ebc-border-strong);
    color: var(--ebc-text);
}

.day-btn.active {
    background: var(--ebc-primary);
    border-color: var(--ebc-primary);
    color: white;
    box-shadow: 0 1px 4px var(--ebc-primary-tint-strong);
}

/* 미지정 버튼 스타일 */
.clear-date-section {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid var(--ebc-border);
    display: flex;
    justify-content: center;
}

.btn-clear-date {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: var(--ebc-btn-h-md);
    padding: 0 14px;
    min-width: 64px;
    font-size: 12px;
    line-height: 1;
    white-space: nowrap;
    box-sizing: border-box;
    width: 100%;
    background: var(--ebc-surface-sunken);
    border: 1px solid var(--ebc-border);
    border-radius: var(--ebc-radius-xs);
    font-weight: 600;
    color: var(--ebc-text-sub);
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-clear-date:hover {
    background: var(--ebc-track);
    border-color: var(--ebc-border-strong);
    color: var(--ebc-text-sub);
}

.btn-clear-date i {
    font-size: 11px;
}

/* 커스텀 드롭다운 스타일 */
.custom-dropdown {
    position: relative;
    width: 100%;
}

.custom-dropdown-trigger {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid var(--ebc-border);
    border-radius: var(--ebc-radius-xs);
    background: var(--ebc-surface);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: all 0.2s ease;
    font-size: 13px;
    font-weight: normal;
    color: var(--ebc-text);
}

.custom-dropdown-trigger:hover {
    border-color: var(--ebc-text-muted);
}

.custom-dropdown-trigger.is-disabled {
    background: var(--ebc-track);
    cursor: not-allowed;
    color: var(--ebc-text-sub);
}

.custom-dropdown.is-open .custom-dropdown-trigger {
    border-color: var(--ebc-primary);
    box-shadow: 0 0 0 3px var(--ebc-primary-tint);
}

.custom-dropdown-trigger .placeholder {
    color: var(--ebc-text-muted);
}

.dropdown-icon {
    font-size: 12px;
    color: var(--ebc-text-sub);
    transition: transform 0.2s ease;
}

.custom-dropdown.is-open .dropdown-icon {
    transform: rotate(180deg);
}

.custom-dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin-top: 4px;
    background: var(--ebc-surface);
    border: 1px solid var(--ebc-border-strong);
    border-radius: var(--ebc-radius-xs);
    box-shadow:
        0 4px 6px -1px rgba(0, 0, 0, 0.1),
        0 2px 4px -1px rgba(0, 0, 0, 0.06);
    z-index: 1000;
    max-height: 300px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.dropdown-search {
    position: relative;
    padding: 8px;
    border-bottom: 1px solid var(--ebc-border);
}

.dropdown-search-input {
    width: 100%;
    padding: 8px 32px 8px 12px;
    border: 1px solid var(--ebc-border-strong);
    border-radius: var(--ebc-radius-xs);
    font-size: 13px;
    outline: none;
    transition: border-color 0.2s ease;
}

.dropdown-search-input:focus {
    border-color: var(--ebc-primary);
    box-shadow: 0 0 0 3px var(--ebc-primary-tint);
}

.search-icon {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--ebc-text-muted);
    font-size: 13px;
    pointer-events: none;
}

.dropdown-list {
    max-height: 240px;
    overflow-y: auto;
    padding: 4px 0;
}

.dropdown-item {
    padding: 10px 12px;
    cursor: pointer;
    font-size: 13px;
    font-weight: normal;
    color: var(--ebc-text);
    transition: background-color 0.15s ease;
}

.dropdown-item:hover {
    background-color: var(--ebc-track);
}

.dropdown-item.is-selected {
    background-color: var(--ebc-primary-tint);
    color: var(--ebc-primary);
    font-weight: normal;
}

.dropdown-item.no-results {
    color: var(--ebc-text-muted);
    text-align: center;
    cursor: default;
    font-style: italic;
}

.dropdown-item.no-results:hover {
    background-color: transparent;
}
</style>
